import { cn } from '../../lib/cn';
import { puCard, puDisplay, puRise, puRoot } from '../PatientUrgency/puClasses';

export { puRoot, puRise, puDisplay };

export const piPublicContainer =
  'relative z-10 mx-auto max-w-[1200px] px-4 pb-[60px] pt-6 md:px-6 md:pb-20 md:pt-9';

export const piPublicCard = cn(
  puCard,
  'flex flex-col gap-4 rounded-[var(--r-xl)] bg-[var(--cream-1)] p-5 shadow-[var(--sh-2)]',
);
